import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import SpeechkitConfigContext, {SpeechkitConfig} from 'contexts/SpeechkitConfigContext';

export type WithSpeechkitConfigProps = {
    speechkitConfig: SpeechkitConfig;
};

export default function withServicesData<T extends WithSpeechkitConfigProps>(
    WrappedComponent: React.ComponentType<T>,
) {
    class WithSpeechkitConfig extends React.Component<Omit<T, keyof WithSpeechkitConfigProps>> {
        static displayName = `withSpeechkitConfig(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;
        static contextType = SpeechkitConfigContext;

        render() {
            return <WrappedComponent {...(this.props as T)} speechkitConfig={this.context} />;
        }
    }

    // Copies non-react specific statics from a child component to a parent component
    hoistNonReactStatics(WithSpeechkitConfig, WrappedComponent);
    return WithSpeechkitConfig;
}
